import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { shortDate } from "LIB/formatters/date";
import { getFirstNameLastInitial, truncate } from "LIB/formatters/text";
import { dollars } from "LIB/formatters/currency";
import { OUTGOING_LINE_ITEMS } from "MODULES/OutgoingQuotes/constants";
import LineItemStatusCell from "MODULES/shared/components/LineItemStatusCell";
import {
  DataTable,
  SearchPropTypes,
  CompanyName
} from "MODULES/shared/components";
import OutgoingQuoteNote from "MODULES/OutgoingQuotes/shared/OutgoingQuoteNote";
import { CONDITIONS_WITH_SERVICEABLE } from "APP_ROOT/constants";
import { LookingForFlags } from "MODULES/OutgoingQuotes/shared/LookingForFlags";

function renderRow(lineItem, i, pushHistory) {
  const handleMailto = e => {
    e.stopPropagation();
  };
  return (
    <tr
      key={lineItem.id}
      className="clickable"
      onClick={() => pushHistory(`/outgoing-quotes/${lineItem.quote_uuid}`)}
    >
      <td>{i + 1}</td>
      <LineItemStatusCell lineItem={lineItem}>
        {lineItem.quote_code}
      </LineItemStatusCell>
      <td>
        <span>{shortDate(lineItem.created_at)}</span>
      </td>
      <td>
        <span className={lineItem.updated_tracked_fields_at && "text-yellow"}>
          {shortDate(lineItem.updated_tracked_fields_at || lineItem.created_at)}
        </span>
      </td>
      <td>{OUTGOING_LINE_ITEMS.quoteType[lineItem.quote_type].label}</td>
      <td>
        {lineItem.created_by &&
          getFirstNameLastInitial(lineItem.created_by.full_name)}
      </td>
      <td>
        <CompanyName flattenedCompany={lineItem} truncateAt={16} />
      </td>
      <td>{lineItem.contact_name}</td>
      <td>
        <LookingForFlags lineItem={lineItem} />
      </td>
      <td>
        <a href={`mailto:${lineItem.contact_email}`} onClick={handleMailto}>
          {`${truncate(lineItem.contact_email, 12)}`}
        </a>
      </td>
      <td>{lineItem.serial_number}</td>
      <td className="text-center">
        {lineItem.trace_type &&
          OUTGOING_LINE_ITEMS.traceTypes[lineItem.trace_type].abbrev}
      </td>
      <td className="text-center">
        {lineItem.condition &&
          CONDITIONS_WITH_SERVICEABLE[lineItem.condition].abbrev}
      </td>
      <td className="text-center">{lineItem.quantity}</td>
      <td className="text-right">
        {lineItem.price_per_unit && dollars(lineItem.price_per_unit)}
      </td>
      <OutgoingQuoteNote lineItem={lineItem} />
    </tr>
  );
}

export function Table(props) {
  const { pushHistory, isLoading, results } = props;

  return (
    <DataTable loading={isLoading} numbered>
      <DataTable.Head>
        <th />
        <th>Quote #</th>
        <th>Created</th>
        <th>Updated</th>
        <th>Type</th>
        <th>Created By</th>
        <th>Customer</th>
        <th>Contact</th>
        <th />
        <th>Email</th>
        <th>Serial #</th>
        <th className="text-center">Trace</th>
        <th className="text-center">Cond</th>
        <th className="text-center">QTY</th>
        <th className="text-right">Price Per Unit</th>
        <th />
      </DataTable.Head>
      <DataTable.Body>
        {results.map((r, i) => renderRow(r, i, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/parts/components/OutgoingQuoteLineItems/Table.jsx